import React, { useEffect } from 'react';

import { observer } from 'mobx-react';
import { Button, Grid, Icon, IconButton, styled } from '@mui/material';
import { useNavigate, useRouteLoaderData } from 'react-router-dom';

import { FlexColumnAlignCenter } from '../../../../../components/common/CommonDivs';
import {
  BellIcon,
  CalendarIcon,
  ContactIcon,
  TVIcon,
  SettingsIcon,
  DeleteIcon,
  WhiteIconButton,
  EditIcon,
  AddIcon
} from '../../../../../components/icons';
import { mediaMobile } from '../../../../../styles/theme';

import { TableColumn } from '../../../../../types/tableColumn';
import { useStores } from '../../../../../stores';
import { AppCardInput, AppCardsDocument, AppCardUpdate, CampQuery, useAppCardsQuery, useCampPermissionQuery, useCreateAppCardMutation, useDeleteAppCardMutation, useUpdateAppCardMutation } from '../../../../../generated/graphql';
import { CustomDialog } from '../../../../../components/common';
import { AutoTableModal } from '../../../../../components/Modals/AutoTableModal';
import { InputType } from '../../../../../types/inputTypes';
import * as MaterialIcons from '@mui/icons-material';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css'; 

const styles = {
  icon: {
    width: 40,
    height: 40,
  } as React.CSSProperties,
  fullHeight: {
    height: '100%',
  },
  delButton: {
    position: 'absolute',
    top: 10,
    right: 10,
    width: 30,
    height: 30,
  } as React.CSSProperties,
  editButton: {
    position: 'absolute',
    top: 10,
    right: 45,
    width: 30,
    height: 30,
  } as React.CSSProperties,
  addButton : {
    marginTop: 20,
  }
};

const AppRouteList = [
 {
    data: {
      id: 0,
      type: 'news',
      name: 'Nyheter',
      icon: '',
      color: '',
      order: 0,
    },
    name: 'Notiser',
    path: 'notifications',
    icon: <BellIcon style={styles.icon} />,
    hideDeleteAndEdit: true,
  },
  {
    data: {
      id: 0,
      type: 'permissions',
      name: 'Behörigheter',
      icon: '',
      color: '',
      order: 0,
    },
    name: 'Behörigheter',
    path: 'permissions',
    icon: <SettingsIcon style={styles.icon} />,
    hideDeleteAndEdit: true,
  },
];

const start_headers: TableColumn[] = [
  {
    title: 'Namn',
    accessor: 'name',
    inputType: InputType.Text,
  },
  {
    title: 'Typ',
    accessor: 'type',
    inputType: InputType.Select,
    values: [
      { id: 'news',
        name: 'Nyheter'
      },
      {
        id: 'schedule',
        name: 'Schema'
      },
      {
        id: 'contact',
        name: 'Kontakter'
      }
      ]
  },
  {
    title: 'Ikon',
    accessor: 'icon',
    inputType: InputType.SelectIcon,
    values: [
      { id: 'MaterialIcons/accessibility', name: 'Människa' },
      { id: 'MaterialIcons/access-time-filled', name: 'Klocka' },
      { id: 'MaterialIcons/accessible', name: 'Rullstolsburen' },
      { id: 'MaterialIcons/account-balance-wallet', name: 'Plånbok' },
      { id: 'MaterialIcons/agriculture', name: 'Traktor' },
      { id: 'MaterialIcons/airplanemode-active', name: 'Flygplan' },
      { id: 'MaterialIcons/airport-shuttle', name: 'Buss' }, 
      { id: 'MaterialIcons/all-inclusive', name: 'Oändligt' }, 
      { id: 'MaterialIcons/alternate-email', name: '@' }, 
      { id: 'MaterialIcons/anchor', name: 'Ankare' }, 
      { id: 'MaterialIcons/android', name: 'Android' }, 
      { id: 'MaterialIcons/announcement', name: 'Pratbubbla' }, 
      { id: 'MaterialIcons/assignment-ind', name: 'Badge' }, 
      { id: 'MaterialIcons/attachment', name: 'Gem' },   
      { id: 'MaterialIcons/audiotrack', name: 'Musik' },   
      { id: 'MaterialIcons/auto-awesome', name: 'Awesome' },   
      { id: 'MaterialIcons/auto-stories', name: 'Bok' },   
      { id: 'MaterialIcons/back-hand', name: 'Hand' }, 
      { id: 'MaterialIcons/bakery-dining', name: 'Croissant' }, 
      { id: 'MaterialIcons/battery-charging-full', name: 'Batteri' }, 
      { id: 'MaterialIcons/beach-access', name: 'Parasoll' }, 
      { id: 'MaterialIcons/bed', name: 'Säng' }, 
      { id: 'MaterialIcons/bedtime', name: 'Måne' }, 
      { id: 'MaterialIcons/bug-report', name: 'Insekt' }, 
      { id: 'MaterialIcons/cake', name: 'Tårta' }, 
      { id: 'MaterialIcons/phone', name: 'Telefon' }, 
      { id: 'MaterialIcons/camera-alt', name: 'Kamera' }, 
      { id: 'MaterialIcons/campaign', name: 'Megafon' }, 
      { id: 'MaterialIcons/celebration', name: 'Party' },                                                                        
      { id: 'MaterialIcons/church', name: 'Kyrka' }, 
      { id: 'MaterialIcons/child-friendly', name: 'Barnvagn' }, 
      { id: 'MaterialIcons/coffee', name: 'Kaffe' }, 
      { id: 'MaterialIcons/computer', name: 'Dator' }, 
      { id: 'MaterialIcons/construction', name: 'Verktyg' }, 
      { id: 'MaterialIcons/cookie', name: 'Kaka' }, 
      { id: 'MaterialIcons/dining', name: 'Bestick' }, 
      { id: 'MaterialIcons/fire-truck', name: 'Brandbil' }, 
      { id: 'MaterialIcons/gpp-good', name: 'Sköld' }, 
      { id: 'MaterialIcons/grade', name: 'Stjärna' }, 
      { id: 'MaterialIcons/group', name: 'Grupp' }, 
      { id: 'MaterialIcons/hot-tub', name: 'Badkar' }, 
      { id: 'MaterialIcons/local-florist', name: 'Blomma' }, 
      { id: 'MaterialIcons/local-pizza', name: 'Pizza' }, 
      { id: 'MaterialIcons/lunch-dining', name: 'Hamburgare' }, 
      { id: 'MaterialIcons/reddit', name: 'Alien' }, 
      { id: 'MaterialIcons/rocket-launch', name: 'Raket' }, 
      { id: 'MaterialIcons/roller-skating', name: 'Rullskridsko' }, 
      { id: 'MaterialIcons/save', name: 'Spara' }, 
      { id: 'MaterialIcons/savings', name: 'Spargris' }, 
      { id: 'MaterialIcons/settings', name: 'Kugghjul' }, 
      { id: 'MaterialIcons/sports-esports', name: 'Handkontroll' }, 
      { id: 'MaterialIcons/vpn-key', name: 'Nyckel' }, 
      { id: 'MaterialIcons/wb-cloudy', name: 'Moln' }, 
      { id: 'MaterialIcons/wb-sunny', name: 'Sol' }, 
      { id: 'MaterialIcons/whatshot', name: 'Eld' }, 
      { id: 'MaterialIcons/water-drop', name: 'Vatten' }, 
    ]
  },
  /*
  {
    title: 'Färg',
    accessor: 'color',
    inputType: InputType.Text,
  },
  {
    title: 'Sorteringsnummer',
    accessor: 'order',
    inputType: InputType.Number,
  },*/
];

export const AppPage = observer(function AppMenu() {
  const nav = useNavigate();
  const camp = useRouteLoaderData('camp') as CampQuery['camp'];
  const camp_id = camp.camp_id;
  const stores = useStores();
  const modalStore = stores.modalStore;
  const [deleteItem] = useDeleteAppCardMutation();
  const [cardList, setCardList ] = React.useState([]);
  const [headers, setHeaders ] = React.useState([]);
  const [headers2, setHeaders2 ] = React.useState([]);

  useCampPermissionQuery({
    variables: {
      camp_id: camp_id!,
    },
    onCompleted: (data) => {
     
      let permissionHeaders = data.campPermissions.map((permission) => {

        return {
          title: permission.name,
          accessor: 'permission_' + permission.id,
          inputType: InputType.Boolean,
        }

      });

      let new_permissions_headers = start_headers.concat(permissionHeaders);
      let new_permissions_headers2 = start_headers.concat(permissionHeaders);
      setHeaders(new_permissions_headers);

      new_permissions_headers2.splice(1, 1);
      setHeaders2(new_permissions_headers2);

    },
  });

  const { data, loading, error } = useAppCardsQuery({
    variables: {
      event_id: camp_id!,
    },
  });

  useEffect(() => {

    let new_list = data?.appCards.map((item) => {
      
      let icon;
      let hideDeleteAndEdit;
      let path;

      if (item.type === 'schedule') {
        icon = getIconComponent(item.icon);
        hideDeleteAndEdit = false;
        path = 'schema';
      }
      if (item.type === 'news') {
        icon = getIconComponent(item.icon);
        hideDeleteAndEdit = false;
        path = 'news';
      }
      if (item.type === 'contact') {
        icon = getIconComponent(item.icon);
        hideDeleteAndEdit = false;
        path = 'contact';
      }

      let data = {};

      data['id'] = item.id;
      data['name'] = item.name;
      data['type'] = item.type;
      data['icon'] = item.icon;
      data['color'] = item.color;
      data['order'] = item.order;

      let permissionData = JSON.parse(item.permissions);

      if (!permissionData) {
        permissionData = [];
      }

      permissionData.forEach((permission) => {
        data['permission_' + permission.id] = permission.value
      });
            
      return {
        data: data,
        name: item.name,
        icon: icon,
        path: path,
        hideDeleteAndEdit: hideDeleteAndEdit,
    }});

    new_list = new_list ? new_list : [];

    new_list.push(...AppRouteList);

    setCardList(new_list);
  }, [data]);



  return (
    <>
    <Grid container spacing={2}>

      {cardList.map((item) => (
        <Grid item key={item.data.id + item.path}>
        {(item.hideDeleteAndEdit) ? (
          <StyledDashboardItemInverted>

          <FlexColumnAlignCenter
              onClick={() => {
                nav(item.data.id + "/" + item.path);
              }}
              
            style={styles.fullHeight}>
              <span>{item.icon}</span>
              <h3>{item.name}</h3>
            </FlexColumnAlignCenter>

          </StyledDashboardItemInverted>
        ) : (

          <StyledDashboardItem

          >
              
              <DeleteIcon style={styles.delButton}
              onClick={() => {

                confirmAlert({
                  title: 'Radera kort',
                  message: 'Är du säker på att du vill radera kortet?',
                  buttons: [
                    {
                      label: 'Ja',
                      onClick: () => {
                        deleteItem({
                          variables: {
                            id: item.data.id,
                            event_id: camp_id!
                          },
                          update: (cache) => {
                            location.reload();
                          }
                        })
                      }
                    },
                    {
                      label: 'Nej',
                      onClick: () => {}
                    }
                  ]
                });



              }} />
              <EditIcon style={styles.editButton} 
              onClick={() => {

                console.log('item', item.data);

                modalStore.updateItem(item.data)
              }} 
              />
             
            <FlexColumnAlignCenter
              onClick={() => {
                nav(item.data.id + "/" + item.path);
              }}
              
            style={styles.fullHeight}>
              <span>{item.icon}</span>
              <h3>{item.name}</h3>
            </FlexColumnAlignCenter>
          </StyledDashboardItem>
        )}
        </Grid>
      ))}
    </Grid>

<WhiteIconButton 
  title='Lägg till nytt kort'
  onClick={() => {
    modalStore.addItem();
  }}
  style={styles.addButton} 
/>

    <AddItem camp_id={camp_id!} headers={headers} />
    <EditItem camp_id={camp_id!} headers={headers2} />
    </>
  );
});



export const StyledDashboardItem = styled(Button)<{ focuscolor?: string }>`
  background: white;
  border-radius: 0;
  border: 1px solid ${(p) => p.theme.palette.primary.main};
  width: 320px;

  height: 240px;

  svg {
    font-size: 30px;
  }
  h3 {
    margin: 4px 0;
    font-weight: 100;
  }
  font-size: 30px;
  text-transform: initial;

  transition-property: background, color;
  color: ${(p) => p.theme.palette.primary.main};

  &:hover,
  &:focus {
    background: ${(p) => p.theme.palette.primary.main};
    color: white;
  }

  ${mediaMobile} {
    width: 280px;
  }
`;

export const StyledDashboardItemInverted = styled(Button)<{ focuscolor?: string }>`
  background: ${(p) => p.theme.palette.primary.main}; 
  border-radius: 0;
  border: 1px solid ${(p) => p.theme.palette.primary.main};
  width: 320px;

  height: 240px;

  svg {
    font-size: 30px;
  }
  h3 {
    margin: 4px 0;
    font-weight: 100;
  }
  font-size: 30px;
  text-transform: initial;

  transition-property: background, color;
  color: white;

  &:hover,
  &:focus {
    background: white; 
    color: ${(p) => p.theme.palette.primary.main};
  }

  ${mediaMobile} {
    width: 280px;
  }
`;

const AddItem = observer(
  ({ camp_id, headers }: { camp_id: number; headers: TableColumn[] }) => {
    const stores = useStores();
    const modalStore = stores.modalStore;

    const [createItem] = useCreateAppCardMutation();

    const close = modalStore.closeAddItemModal;

    return (
      <CustomDialog open={modalStore.showingAddItemModal} onClose={close}>
        <AutoTableModal
          title="app-kort"
          headers={headers}
          onCancel={close}
          existingItem={{
            name: '',
            type: 'news',
            icon: 'MaterialIcons/accessibility',
            color: '',
            order: 0,
          }}
          onSubmit={async (data) => {

            let permissionData = [];

            for (const [key, value] of Object.entries(data)) {
              if (key.includes('permission_')) {
                permissionData.push({
                  id: parseInt(key.split('_')[1]),
                  value: value
                });

                delete data[key];
              }
            }

            data.permissions = JSON.stringify(permissionData);

            if (!data.icon) {
              data.icon = 'MaterialIcons/accessibility';
            }
            if (!data.type) {
              data.type = 'news';
            }

            data.event_id = camp_id;
            await createItem({
              variables: {
                appCard: data as AppCardInput,
              },
              update: () => {
                location.reload();
              },
            });
            close();
          }}
        />
      </CustomDialog>
    );
  },
);

const EditItem = observer(
  ({ camp_id, headers }: { camp_id: number; headers: TableColumn[] }) => {
    const stores = useStores();
    const modalStore = stores.modalStore;
    const [updateItem] = useUpdateAppCardMutation();

    const close = modalStore.closeUpdateItemModal;

    return (
      <CustomDialog open={modalStore.showingUpdateItemModal} onClose={close}>
        <AutoTableModal
          title="app-kort"
          headers={headers}
          existingItem={modalStore.existingItem}
          onCancel={close}
          onSubmit={(data) => {

            let permissionData = [];

            for (const [key, value] of Object.entries(data)) {
              if (key.includes('permission_')) {
                permissionData.push({
                  id: parseInt(key.split('_')[1]),
                  value: value
                });

                delete data[key];
              }
            }

            data.permissions = JSON.stringify(permissionData);

            data.event_id = camp_id;
            data.id = modalStore.existingItem.id;
            updateItem({
              variables: {
                appCard: data as AppCardUpdate,
              },
              update: () => {
                location.reload();  
              }
            });
            close();
          }}
        />
      </CustomDialog>
    );
  },
);


const kebabToCamelCase = (str) => {
  str = str.replace(/-./g, (match) => match[1].toUpperCase());
  return str.charAt(0).toUpperCase() + str.slice(1);
};

// Function to return the correct icon component based on the id
const getIconComponent = (id) => {
  // Remove 'MaterialIcons/' prefix to match the actual component name
  const iconName = id.replace('MaterialIcons/', '');

  // Get the specific icon component from MaterialIcons
  const IconComponent = MaterialIcons[kebabToCamelCase(iconName)];

  // If the icon is found, return it
  if (IconComponent) {
    return <IconComponent style={styles.icon} />;
  }

  // Return a default fallback if the icon is not found
  return <MaterialIcons.HelpOutline />;
};